export default __webpack_public_path__ + "static/media/gradient_bg_03.766ba557.jpg";